// LLM generated - Model Claude 4 Sonnet
import { Text } from '~/domains/design-system/Text';
import type { textStyles } from '~/domains/design-system/Text';

type HeaderSubtitleProps = {
  text: string;
  variant?: keyof typeof textStyles;
};

export function HeaderSubtitle({ text, variant = 'subhead-large' }: HeaderSubtitleProps) {
  return (
    <Text variant={variant} c="gray2.4">
      {text}
    </Text>
  );
}
